import { useRef, useState, useCallback, use } from 'react';
import { useParams } from 'next/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import { fetchSectionData } from '@/lib/get-data';

//* HOC's
import withLanguageContext from '@/context/consumerHOC/LanguageConsumer';

//* Components
import Text from '../../Text';
import Button from '@components/global/Button';
import CustomLink from '@components/global/CustomLink';

const TestimonialContent = ({ translate, items: outsideItems }) => {
	const params = useParams();
	const items = outsideItems || use(fetchSectionData({ name: 'getHomeTestimonials', lang: params.locale }));

	if (!items) return;

	//! Refs
	const sliderRef = useRef();

	//! States
	const [activeSlide, setActiveSlide] = useState(0);

	//! Change Slide
	const changeSlide = useCallback((key) => {
		setActiveSlide(key);
		sliderRef.current.slideTo(key);
	}, []);

	return (
		<>
			<Swiper
				className={'slideContainer'}
				slidesPerView={1}
				spaceBetween={40}
				modules={[Autoplay]}
				autoplay={{
					delay: 5000,
					disableOnInteraction: false,
				}}
				onSwiper={(swiper) => (sliderRef.current = swiper)}
				onSlideChange={(e) => setActiveSlide(e.activeIndex)}>
				{items.map((i, k) => {
					return (
						<SwiperSlide
							key={k}
							className={'slide'}>
							<div className={'slideInner'}>
								<i className={`cs-quote slideSymbol`} />

								<Text className={`h5 font-poppins slideText`}>{i.text}</Text>

								<div className={'slideInfoCont'}>
									<Text className={`h6 font-poppins font-semi-bold slideInfo`}>
										{`${i.name} ${i.position}, `}
										{i.company_url ? (
											<CustomLink
												external
												url={i.company_url}
												className='font-underline'>
												{i.company_name}
											</CustomLink>
										) : (
											`${i.company_name}`
										)}
									</Text>

									{i.clutch_url && (
										<div className={'slideButtonCont'}>
											<Button
												otherLinkProps={{ target: '_blank' }}
												className={'slideButton'}
												otherLink={{
													pathname: i.clutch_url,
												}}
												text={translate('viewOnClutch')}
											/>
										</div>
									)}
								</div>
							</div>
						</SwiperSlide>
					);
				})}
			</Swiper>

			{items.length > 1 ? (
				<div className={'pagination'}>
					{items.map((i, k) => {
						return (
							<span
								key={k}
								onClick={() => changeSlide(k)}
								className={`paginationItem ${k === activeSlide ? 'paginationItemActive' : ''}`}
							/>
						);
					})}
				</div>
			) : null}
		</>
	);
};

export default withLanguageContext(TestimonialContent, ['translate']);
